import { CheckCircle2, AlertTriangle, XCircle, HelpCircle } from "lucide-react";

export const FACT_STATUS_STYLES = {
  "Confirmé": { classes: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30", icon: CheckCircle2 },
  "À vérifier": { classes: "bg-amber-500/15 text-amber-600 border-amber-500/30", icon: AlertTriangle },
  "Contesté": { classes: "bg-rose-500/15 text-rose-600 border-rose-500/30", icon: XCircle },
  "Information manquante": { classes: "bg-slate-500/15 text-slate-700 border-slate-500/30", icon: HelpCircle },
};

export default function FactStatusBadge({ status }) {
  const style = FACT_STATUS_STYLES[status] || FACT_STATUS_STYLES["À vérifier"];
  const Icon = style.icon;
  return (
    <span
      data-testid="fact-status-badge"
      className={`inline-flex items-center gap-1.5 font-mono text-[10px] uppercase px-2 py-0.5 rounded-sm border ${style.classes}`}
    >
      <Icon className="h-3 w-3" />
      {status}
    </span>
  );
}
